import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { useMutation } from '@tanstack/react-query';
import { AuthFormTitle } from './layout/index';
import { AuthFormAction } from './layout/index';
import TextInput from '../../inputs/text';
import { Button } from 'components/button/Button';
import { ReactComponent as Back } from '../../../assets/icons/arrow-left-circle.svg';
import { loginUserApi } from 'api/apiRequest';
import errorHandler from 'handlers/errorHandler';
import { useNavigate } from 'react-router-dom';

type Props = {
	setFormView: React.Dispatch<React.SetStateAction<any>>;
};

export const LoginOtpForm: FC<Props> = ({ setFormView }) => {
	const navigate = useNavigate();

	const [data, setData] = useState('');
	const { email, password } = useSelector((state: any) => state.authReducer);

	const { mutate, isLoading } = useMutation(loginUserApi, {
		onError: (error: Error) => {
			errorHandler(error, true);
		},
		onSuccess: (res: any) => {
			localStorage.setItem('game-user-token', res?.data?.accessToken);
			localStorage.setItem('game-user-secret', res?.data?.accessSecret);
			localStorage.setItem('game-user-obj', JSON.stringify(res?.data?.user));
			// setFormView('onboarding');
			navigate('/');
		},
		retry: 0,
	});

	const onSubmit = () => {
		const formData = {
			username: email,
			password: password,
			code: data,
		};
		mutate(formData);
	};

	return (
		<div className="lg:grid grid-cols-1 sm:grid-cols-2 items-center gap-5 text-white px-0 sm:px-4">
			<AuthFormTitle>
				Sign up to join a community of millions of players.
			</AuthFormTitle>

			<AuthFormAction>
				<div
					className="flex gap-2 items-center mb-3 cursor-pointer"
					onClick={() => setFormView('join')}
					data-testid="to-join-button"
				>
					<Back className="w-[34px] h-[34px]" />
					<h3 className="text-2xl font-bold">Authenticator App Code</h3>
				</div>
				<p className="font-medium text-grey mb-10">
					Please enter the 2FA code from your authenticator app
				</p>

				<TextInput
					type={'text'}
					data-testid="verification-code"
					label={'Enter verification code'}
					onChange={(e) => setData(e.target.value)}
				/>

				<Button
					text={'Confirm'}
					loading={isLoading}
					data-testid="verification-button"
					className={
						'text-[15px] text-black font-bold btn-primary h-[56px] rounded-full mb-3 mt-5 justify-center block w-full px-8'
					}
					onClick={() => onSubmit()}
				/>
			</AuthFormAction>
		</div>
	);
};
